import { Modal } from "antd";
import React from "react";
import IMAGES from "../../constants/images";
import { navigateTo } from "../../utils/navigation";

export default function GoBackModel({ goBackModel, setGoBackModel }) {
  return (
    <Modal
      title=""
      closable={{ "aria-label": "Custom Close Button" }}
      open={true}
      onOk={() => setGoBackModel(!goBackModel)}
      onCancel={() => setGoBackModel(!setGoBackModel)}
      footer={null}
      modalRender={(modal) => (
        <div className="flex justify-center items-center w-full h-full">
          <div className="w-2/3">{modal}</div>
        </div>
      )}
    >
      <div className="relative px-2 py-2">
        <div className="flex flex-col justify-center items-center min-h-[260px]">
          <img
            src={IMAGES.failed_Call}
            alt="img"
            className="w-[120px] h-[120px]"
          />
          <span className="text-[#4B61FF] text-[14px] font-bold text-center font-poppins">
            End Call Confirmation
          </span>
          <span className="text-[#171717] font-semibold text-[10px] font-poppins text-center mt-2 text-center">
            Are you sure you want to end the call
          </span>
          <span className="text-[#171717]  text-[10px] font-poppins text-center mt-1 text-center">
            The member has not joined within 15 min
          </span>
        </div>
        <div className="w-full h-[40px] absolute bottom-2 flex  justify-between items-center bg-[#FFFFFF] ">
          <button
            className="h-[40px] w-[140px] bg-[#FFFFFF]  font-poppins text-[14px] mt-[30px] border-1 "
            style={{
              border: "1px solid grey",
              color: "grey",
            }}
            onClick={() => {
              setGoBackModel(!goBackModel);
            }}
          >
            Cancel
          </button>
          <button
            className="h-[40px] w-[140px] btn-gradient rounded-xl text-[#FFFFFF] font-poppins text-[14px] mt-[30px]"
            onClick={() => {
              setGoBackModel(!goBackModel);
              navigateTo("/upcoming-appointments/upcoming");
            }}
          >
            Yes, end call
          </button>
        </div>
      </div>
    </Modal>
  );
}
